<template lang="pug">
ClientOnly
  v-dialog(v-model='dialog', max-width='30rem')
    template(#activator='{ props }')
      v-btn(
        plain,
        x-small,
        v-bind='props',
        prepend-icon='mdi-qrcode',
        variant='plain'
      ) QR-Code
    .qr-dialog
      .qr-header
        p.qr-kicker Quick Access
        h2.qr-title Contact QR Code
        p.qr-copy Scan to transfer the contact details directly to another device.
      .qr-code-frame
        qrcode-vue(
          v-if='dialog'
          :value='text'
          :size='280'
          level='M'
          :foreground='qrForeground'
          :background='qrBackground'
          margin='2'
        )
      .qr-actions
        v-btn(
          color='primary'
          variant='outlined'
          @click='dialog = false'
        ) Close
</template>

<script setup>
import { defineAsyncComponent } from 'vue'

defineOptions({
  name: 'QrCode',
})

defineProps({
  text: { type: String, required: true },
})

const dialog = ref(false)
const qrForeground = '#17212b'
const qrBackground = '#ffffff'
const QrcodeVue = defineAsyncComponent(() => import('qrcode.vue'))
</script>

<style scoped>
.qr-dialog {
  padding: 1.25rem;
  border: 1px solid var(--border-default);
  background:
    linear-gradient(
      180deg,
      color-mix(in srgb, var(--surface-soft) 95%, white) 0%,
      var(--surface-card) 100%
    ),
    radial-gradient(
      circle at top right,
      rgba(0, 192, 216, 0.08),
      transparent 14rem
    );
}

.qr-header {
  display: grid;
  gap: 0.45rem;
}

.qr-kicker {
  margin: 0;
  color: var(--color-accent-soft);
  text-transform: uppercase;
  letter-spacing: 0.16em;
  font-size: 0.72rem;
  font-weight: 700;
}

.qr-title {
  margin: 0;
  font-size: clamp(1.45rem, 2.2vw, 1.8rem);
  line-height: 1.02;
}

.qr-copy {
  margin: 0;
  color: var(--color-text-muted);
}

.qr-code-frame {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 1.1rem;
  padding: 1rem;
  border: 1px solid var(--border-default);
  background: white;
}

.qr-actions {
  display: flex;
  justify-content: flex-end;
  margin-top: 1rem;
}

@media (max-width: 760px) {
  .qr-dialog {
    padding: 1rem;
  }

  .qr-code-frame {
    padding: 0.75rem;
  }
}
</style>
